import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'

import i18n from 'i18n'

import { RootState, Discount } from './types'
import { mutations } from './mutations'
import { getters } from './getters'
import { actions } from './actions'
import { plugins } from './plugins'

import { PaymentGateway, PaymentState, SalesContactType } from 'proto/eshop/Basket_pb'

Vue.use(Vuex)

const store = new Vuex.Store<RootState>({
	strict: true,
	plugins,

	state: {
		products: [],
		userInfo: {
			fullName: '',
			email: '',
			phone: '',
			postcode: '',
			city: '',
			address: '',
			acceptMarketingMessages: false,
			isAgree: false,
			dntSendTo3rdParties: false,
			paymentOption: PaymentGateway.NO_PAYMENT_GATEWAY,
			deliveryOption: 0,
			deliveryPrice100: 0,
			orderComment: '',
		},
		discount: new Discount(),
		paymentStateValue: null,
		paymentStateMap: {
			[PaymentState.NO_ORDER_STATE]: {
				title: i18n.pgettext('payment state', 'None'),
				color: '#6D757D',
			},
			[PaymentState.INITIATED]: {
				title: i18n.pgettext('payment state', 'Initiated'),
				color: '#6D757D',
			},
			[PaymentState.IN_PROGRESS]: {
				title: i18n.pgettext('payment state', 'In progress'),
				color: '#6D757D',
			},
			[PaymentState.WAITING_FOR_SETTLEMENT]: {
				title: i18n.pgettext('payment state', 'Waiting for settlement'),
				color: '#6D757D',
			},
			[PaymentState.CONFIRMED]: {
				title: i18n.pgettext('payment state', 'Confirmed'),
				color: '#6D757D',
			},
			[PaymentState.CANCELLED]: {
				title: i18n.pgettext('payment state', 'Cancelled'),
				color: '#FF0000',
			},
			[PaymentState.DENIED]: {
				title: i18n.pgettext('payment state', 'Denied'),
				color: '#FF0000',
			},
			[PaymentState.REFUND_REQUEST]: {
				title: i18n.pgettext('payment state', 'Refund request'),
				color: '#FF0000',
			},
			[PaymentState.REFUND_PROCESSING]: {
				title: i18n.pgettext('payment state', 'Refund processing'),
				color: '#FF0000',
			},
			[PaymentState.RETURNED]: {
				title: i18n.pgettext('payment state', 'Returned'),
				color: '#FF0000',
			},
			[PaymentState.REVERSED]: {
				title: i18n.pgettext('payment state', 'Reversed'),
				color: '#FF0000',
			},
			[PaymentState.SETTLED]: {
				title: i18n.pgettext('payment state', 'Settled'),
				color: '#58BD46',
			},
		},
		salesContactTypeMap: {
			[SalesContactType.NO_CONTACT_TYPE]: {
				label: '',
				link: '',
			},
			[SalesContactType.TEL]: {
				label: 'Tel.',
				link: 'tel:',
			},
			[SalesContactType.EMAIL]: {
				label: 'E-mail',
				link: 'mailto:',
			},
		},
	},

	mutations,
	getters,
	actions,
} as StoreOptions<RootState>)

export default store
